<template>
  <div class="case">
    <van-nav-bar fixed placeholder title="我的积分" left-arrow @click-left="$router.go(-1)">
    </van-nav-bar>
    <van-tabs v-model="news.active" sticky>
      <van-tab v-for="(tab,index) in news.tabs" :key="index" :title="tab.title">
        <div class="newslist">
          <van-list v-if="index==1" v-model="tab.loading" :finished="tab.finished" finished-text="" @load="loadCaseList(index)">
            <van-cell title-style="text-align:left;" v-for="item in tab.list" :key="item.id" :title="item.title" :value="item.score+'分'" :label="global.formatDate(item.createTime,'yyyy-MM-dd')">
              <!-- <template #right-icon>
              </template> -->
            </van-cell>
          </van-list>
          <van-list v-if="index==0" v-model="tab.loading" :finished="tab.finished" finished-text="" @load="loadCaseList(index)">
            <van-cell title-style="text-align:left;" v-for="item in tab.list" :key="item.id" :title="item.productName" :value="item.days+'分'" :label="global.formatDate(item.createDate,'yyyy-MM-dd')">
              <!-- <template #right-icon>
              </template> -->
            </van-cell>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
    <van-tabbar fixed style="height:130px">
      <div class="m-l-10 m-r-10 m-t-30" style="width:100%">
        <van-button type="primary" :replace="true" url="product?productType=1" block>购买积分</van-button>
        <div class="m-t-20 f-14" @click="rule.show=true">积分规则</div>
      </div>
    </van-tabbar>
    <van-action-sheet v-model="rule.show" title="积分规则">
      <div class="jifenrulecontent f-14">
        <ul>
          <li>1、积分只能用于查询案例，不能用于查阅资料；</li>
          <li>2、每查询一次案例扣除相应积分;</li>
          <li>3、用户充值的积分不可共享，不可兑换现金；</li>
          <li>4、帮手发布案例且被浏览可获得相应积分返佣；</li>
          <li>5、帮手返佣积分可兑换现金，仅限每个自然月末兑换；</li>
          <li>6、积分可通过直接购买或者升级VIP获得；</li>
        </ul>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  Icon,
  Cell,
  CellGroup,
  Image as VanImage,
  Tag,
  Popup,
  NavBar,
  Form,
  Button,
  Field,
  CountDown,
  Toast,
  List,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  ActionSheet,
} from "vant";
import { Get_Case_View_Log_List, Get_Order_Item_List } from "@/api/index";
export default {
  name: "UserScore",
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [VanImage.name]: VanImage,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Button.name]: Button,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [List.name]: List,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      news: {
        active: 0,
        tabs: [
          {
            title: "充值记录",
            list: [],
            loading: false,
            finished: false,
            page: 1,
          },
          {
            title: "消费记录",
            list: [],
            loading: false,
            finished: false,
            page: 1,
          },
        ],
      },
      rule: {
        show: false,
      },
    };
  },
  methods: {
    loadCaseList(index) {
      this.news.tabs[index].loading = true;
      if (index == 0) {
        Get_Order_Item_List({
          memberId: this.user.memberId,
          shopType: 1,
          pageSize: 20,
          page: this.news.tabs[index].page,
        }).then((data) => {
          this.news.tabs[index].finished =
            data.pageCount <= this.news.tabs[index].page;
          this.news.tabs[index].list = this.news.tabs[index].list.concat(
            data.dataList
          );
          this.news.tabs[index].page++;
          this.news.tabs[index].loading = false;
        });
      } else {
        Get_Case_View_Log_List({
          memberId: this.user.memberId,
          shopType: 1,
          pageSize: 20,
          page: this.news.tabs[index].page,
        }).then((data) => {
          this.news.tabs[index].finished =
            data.pageCount <= this.news.tabs[index].page;
          this.news.tabs[index].list = this.news.tabs[index].list.concat(
            data.dataList
          );
          this.news.tabs[index].page++;
          this.news.tabs[index].loading = false;
        });
      }
    },
  },
  mounted: function () {},
};
</script>
